import React from "react";
import { useTranslation } from "react-i18next";

import { LogStreamerOptions, useLogStreamer } from "@dashboard/products/components/LogStreamer/LogStreamer";
import { DropdownItem } from "@devices/components/shared";
import DropdownContainer from "@devices/components/shared/Dropdown/DropdownContainer";

/**
 * The "More actions" menu of a build row. It always offers the build's logs; pass further `DropdownItem`s as children,
 * never wrapped in a fragment.
 */
export const BuildActionsMenu = (props: React.PropsWithChildren<LogStreamerOptions>) => {
    const { t } = useTranslation(["common"]);
    const { openLogs, logStreamModal } = useLogStreamer(props);

    return (
        <React.Fragment>
            <DropdownContainer
                icon={<i className="fa-solid fa-ellipsis-vertical" />}
                tooltipProps={{ title: t("common:tooltip.moreActions") }}
            >
                <DropdownItem
                    label={t("common:section.logStreamer.showBuildLogs")}
                    iconName="fa-solid fa-fw fa-align-left"
                    onClick={openLogs}
                    disabled={!props.hasLogs}
                    tooltipProps={{ title: t("common:section.logStreamer.noLogsAvailable"), hide: props.hasLogs }}
                />
                {props.children}
            </DropdownContainer>
            {logStreamModal}
        </React.Fragment>
    );
};
